import {
  FETCH_TRANSACTION_END,
  FETCH_TRANSACTION_END_CAMPAIGN,
  FETCH_TRANSACTION_START,
  FETCH_TRANSACTION_START_CAMPAIGN,
  SAVE_CAMPAIGNS,
  SAVE_STATS,
  SAVE_STATS_CAMPAIGN,
  SAVE_STATS_START,
  SAVE_STATS_START_CAMPAIGN,
  SAVE_TRANSACTION,
  SAVE_TRANSACTION_CAMPAIGN,
  SAVE_TRANSACTION_PAGE,
  SAVE_TRANSACTION_PAGE_CAMPAIGN,
  SAVE_TRANSACTION_START,
  SAVE_TRANSACTION_START_CAMPAIGN,
  SAVE_TRANSACTIONS_LIST
} from "appRedux/constants";
import { SS } from "utils";
import { SAVING_CAMPAIGNS } from "../constants";

const INIT_STATE = {
  loading: false,
  transactions: [],
  campaigns: [],
  loading_stats: false,
  stats: [],
  transactionPages: [],

  loading_campaign: false,
  transactions_campaign: [],
  loading_stats_campaign: false,
  stats_campaign: [],
  transactionPages_campaign: []
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case FETCH_TRANSACTION_START: {
      return {
        ...state,
        loading: true
      };
    }
    case FETCH_TRANSACTION_END: {
      return {
        ...state,
        loading: false
      };
    }
    case SAVE_TRANSACTION_START: {
      return {
        ...state,
        loading: true
      };
    }
    case SAVE_TRANSACTION: {
      SS.save("transactions", action.payload);
      return {
        ...state,
        loading: false,
        transactions: action.payload
      };
    }
    case SAVE_TRANSACTIONS_LIST: {
      SS.save("transactions", action.payload);
      return {
        ...state,
        loading: false,
        transactions: action.payload
      };
    }
    case SAVE_STATS_START: {
      return {
        ...state,
        loading_stats: true
      };
    }
    case SAVE_STATS: {
      return {
        ...state,
        loading_stats: false,
        stats: action.payload
      };
    }
    case SAVE_TRANSACTION_PAGE: {
      return {
        ...state,
        loading: false,
        transactionPages: action.payload
      };
    }

    case FETCH_TRANSACTION_START_CAMPAIGN: {
      return {
        ...state,
        loading_campaign: true
      };
    }
    case FETCH_TRANSACTION_END_CAMPAIGN: {
      return {
        ...state,
        loading_campaign: false
      };
    }
    case SAVE_TRANSACTION_START_CAMPAIGN: {
      return {
        ...state,
        loading_campaign: true
      };
    }
    case SAVE_TRANSACTION_CAMPAIGN: {
      return {
        ...state,
        loading_campaign: false,
        transactions_campaign: action.payload
      };
    }
    case SAVE_STATS_START_CAMPAIGN: {
      return {
        ...state,
        loading_campaign: true
      };
    }
    case SAVE_STATS_CAMPAIGN: {
      return {
        ...state,
        loading_campaign: false,
        stats_campaign: action.payload
      };
    }
    case SAVE_TRANSACTION_PAGE_CAMPAIGN: {
      return {
        ...state,
        loading_campaign: false,
        transactionPages_campaign: action.payload
      };
    }
    case SAVING_CAMPAIGNS: {
      return {
        ...state,
        loading_campaign: true
      };
    }
    case SAVE_CAMPAIGNS: {
      return {
        ...state,
        loading_campaign: false,
        campaigns: action.payload
      };
    }
    default:
      return state;
  }
};
